import apiClient from "@/app/api/client";
import { notificationEndpoints } from "@/app/api/endpoints";
import type { NotificationListParams, NotificationPaginatedResponse } from "../types";

export const notificationService = {
	async list(params?: NotificationListParams): Promise<NotificationPaginatedResponse> {
		const response = await apiClient.get<NotificationPaginatedResponse>(
			notificationEndpoints.list,
			{ params }
		);
		return response.data;
	},
};
